import Vue from 'vue'
import VueMoment from 'vue-moment'

const moment = require('moment')

moment.defaultFormat = 'DD.MM.YYYY'

Vue.use(VueMoment, {
  moment
})
